import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

const PAGE_PATHS = { new_glitch: "/", status: "/status", closed: "/closed", guest_log: "/guest-log", board: "/board", guest_card: "/guest-card", reports: "/reports" };

export default function ProtectedRoute({ children, adminOnly, page }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-[#4e73df] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  const isAdmin = user.role === "admin";

  if (adminOnly) {
    const hasAdminAccess = isAdmin || (user.permissions?.admin_sections || []).length > 0;
    if (!hasAdminAccess) return <Navigate to="/" replace />;
  }

  if (page && !isAdmin) {
    const allowed = user.permissions?.pages || [];
    if (!allowed.includes(page)) {
      const fallback = allowed.find((p) => PAGE_PATHS[p]);
      if (fallback) return <Navigate to={PAGE_PATHS[fallback]} replace />;
      return (
        <div className="min-h-screen flex items-center justify-center text-center px-4">
          <div>
            <p className="font-semibold text-slate-600">No pages are enabled for your account yet.</p>
            <p className="text-sm text-slate-400 mt-1">Ask an admin to grant access under Admin → Roles.</p>
          </div>
        </div>
      );
    }
  }
  return children;
}
